import ApiService from '@/services/api';

// TYPES

export type TCreateTransactionParams = unknown;
export type TCreateTransactionBody = unknown;

export type TCreateTransactionMaterials = {
  params?: TCreateTransactionParams;
  body?: TCreateTransactionBody;
  useAdmin?: boolean;
};

export type TCreateTransactionResponse = unknown;

// FUNCTION

export const createTransaction = async ({
  params,
  body,
  useAdmin = true,
}: TCreateTransactionMaterials): Promise<TCreateTransactionResponse> => {
  const response = await ApiService.post(`/v1/api${useAdmin ? '/admin' : ''}/transactions`, body, { params });
  return response.data;
};
